import React, { useState } from "react";
import GoogleMapReact from "google-map-react";
import MarkerMaps from "../component/molecules/maps/MarkerMaps";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  IconButton
} from "@material-ui/core";
import InputJembatan from "../component/molecules/popup/InputJembatan";
import { fetchApi, getImage } from "../helper/api";
import { useEffect } from "react";
import DetailJembatan from "../component/molecules/popup/DetailJembatan";
import { isRoleHasAcces } from "../helper/function";
import { engineer, superUser } from "../helper/constantRole";
import { connect } from "react-redux";

function Maps(props) {
  const navigate = useNavigate();
  const defaultProps = {
    center: {
      lat: -2.991452571388209,
      lng: 104.76358488575511,
    },
    zoom: 13,
  };
  const [openCreator, setOpenCreator] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [longLat, setLongLat] = useState();
  const [listJembatan, setListJembatan] = useState([]);
  const [idJembatan, setIdJembatan] = useState();
  const [typeDialog, setTypeDialog] = useState("edit");
  const [dataIndividualBridge, setDataIndividualBridge] = useState(null);

  useEffect(() => {
    getJembatan();
  }, []);

  const getJembatan = async () => {
    const req = await fetchApi("api/Bridge", "get", true);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      setListJembatan(res.data);
    }
  };

  const updateDetails = async (id) => {
    const req = await fetchApi(`api/Bridge/details/${id}`, "get", true);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      setDataIndividualBridge(res.data);
    }
  };

  const showMarker = () => {
    return listJembatan.map((e, i) => {
      return (
        <MarkerMaps
          key={i}
          lat={e.latitude}
          lng={e.longitude}
          bridge={{
            isUsable: true,
            status: 3,
            name: e.namaJembatan,
            lastSensorTrigered: e.lastTrigered,
            // img: 'https://hallo.palembang.go.id/petalokasi/login/assets/file/gambar/Jembatan-Ampera.jpg'
            img: getImage(e.imgPath),
          }}
          element={
            // <IconButton
            //     onClick={() => navigate(`/${props.tipe == "sensor" ? "sensor" : "structure"}-monitor/${e._id}`)}
            //     style={{
            //         backgroundColor: 'green',
            //         width: 15,
            //         height: 15,
            //         transform: "translate(-50%, -50%)",
            //     }}
            //     size={"small"}
            // />
            <IconButton
              onClick={() => {
                setIdJembatan(e._id);
                setDataIndividualBridge(e);
              }}
              data-toggle="modal"
              data-target="#detailJembatan"
              style={{
                backgroundColor: "green",
                width: 15,
                height: 15,
                transform: "translate(-50%, -50%)",
              }}
              size={"small"}
            />
          }
        />
      );
    });
  };

  return (
    <>
      <DetailJembatan
        idJembatan={idJembatan}
        tipe={props.tipe}
        callback={() => {
          getJembatan();
          setIdJembatan();
        }}
        openEdit={() => {
          setOpenCreator(true);
        }}
        changeTypeDialog={() => setTypeDialog("edit")}
      />
      <Dialog
        open={openCreator}
        onClose={() => setOpenCreator(false)}
        maxWidth="md"
      >
        <h1 className="mx-4 mt-4 mb-0">
          {`${typeDialog === "add" ? "Tambah" : "Edit"} Jembatan`}
        </h1>
        <InputJembatan
          tutupDialog={() => setOpenCreator(false)}
          data={longLat}
          dataIndividualBridge={dataIndividualBridge}
          type={typeDialog}
          updateData={(id) => {
            getJembatan();
            updateDetails(id);
          }}
        />
      </Dialog>
      <div className="m-3 d-flex justify-content-between align-items-center">
        <h1
          className="wrap-judul position-relative bg-white px-3 py-2 float-left"
          style={{ zIndex: 2, borderLeft: "4px solid green" }}
        >
          Pemantauan {props.tipe === "sensor" ? "Sensor" : "Struktur"}
        </h1>
        <div className="wrap-judul position-relative z-2">
          {addMode ? (
            <button
              className="btn btn-light d-flex align-items-center"
              onClick={() => setAddMode(false)}
            >
              <i className="las la-times mr-2"></i>
              Cancel
            </button>
          ) : (
            isRoleHasAcces([engineer, superUser], props._dataProfile.role) &&
            <button
              className="btn btn-warning d-flex align-items-center"
              onClick={() => {
                setTypeDialog("add");
                setAddMode(true);
              }}
            >
              <i className="las la-plus mr-2"></i>
              Tambah Jembatan
            </button>
          )}
        </div>
      </div>
      <div className="position-absolute top-0 inset-0">
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyDuOGU8Es_pFWlNiZGirsVeKXZTOZKf_Gw" }}
          yesIWantToUseGoogleMapApiInternals={true}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          onClick={(e) => {
            if (addMode) {
              console.log(e);
              setLongLat({ lng: e.lng, lat: e.lat });
              setOpenCreator(true);
              setAddMode(false);
            }
          }}
          options={{
            draggableCursor: addMode ? "crosshair" : "",
            styles: [
              {
                featureType: "administrative",
                elementType: "geometry",
                stylers: [
                  {
                    visibility: "off",
                  },
                ],
              },
              {
                featureType: "poi",
                stylers: [
                  {
                    visibility: "off",
                  },
                ],
              },
              {
                featureType: "road",
                elementType: "labels.icon",
                stylers: [
                  {
                    visibility: "off",
                  },
                ],
              },
              {
                featureType: "transit",
                stylers: [
                  {
                    visibility: "off",
                  },
                ],
              },
            ],
            disableDefaultUI: true,
          }}
        >
          {showMarker()}
        </GoogleMapReact>
      </div>
    </>
  );
}
const mapState = (state) => {
  return {
    _dataProfile: state.dataProfile
  };
};
export default connect(mapState)(Maps)